import apiClient from '@/services/axios'

class PostBranchesService {
  constructor() {
    this.$api = apiClient
  }

  // request major post offices
  fetchAllPostBranches () {
    return this.$api.get('/admin/post-branches')
  }

  getBranches (id) {
    return this.$api.get(`/admin/post-branch/info/${id}`)
  }

  getBranch (id) {
    return this.$api.get(`/admin/post-branch/info/one/${id}`)
  }

  createBranch (data) {
    return this.$api.post('/admin/post-branch/info', data)
  }

  updateBranch (id, data) {
    return this.$api.put(`/admin/post-branch/info/${id}`, data)
  }

  deleteBranch (id) {
    return this.$api.delete(`/admin/post-branch/info/${id}`)
  }
}

export default new PostBranchesService()
